<template>
  <div class="Journalism">
    <div class="Journalism_wrap">
      <div class="Journalism_banner">
        <p>{{$t("Journalism.Journalismtitle")}}</p>
      </div>
    </div>
    <div class="Journalism_wrapa clear">
      <div class="Journalism_news">
        <div class="Journalism_news_title">
          <headerbar v-bind:message="$t(parentMeg)"></headerbar>
        </div>
        <div class="Journalism_news_content">
          <ul>
            <li v-for="(item,index) in news" :key="index">
              <a @click="newsbutton(item.src)">
                <div class="Journalism_news_img">
                  <img v-lazy="item.img" alt="">
                </div>
                <h3>{{item.title}}</h3>
                <p>{{item.text}}</p>
                <h6>{{item.date}}</h6>
                <span></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerbar from "../components/common/header.vue"
export default {
  name: 'Journalism',
  data() {
    return {
      clientHeight: "",
      parentMeg: "Journalism.new",
      news: [
        {
          "src":"https://mp.weixin.qq.com/s/oZtOVCMtXXYvJuw5p_bUtg",
          "img": require("../assets/images/xwgg.png"),
          "title": "CITE2021完美收官，开易科技大放异彩",
          "text": "开易科技携全谱系主动安全智能产品及热门行业应用解决方案亮相展会。",
          "date": "2021.04.20",
        },
         {
          "src":"https://mp.weixin.qq.com/s/zlQGvQbd9fslPPZyM5_EtQ",
          "img": require("../assets/images/xwkk.png"),
          "title": "开易科技：如何在ADAS行业乘风破浪？“技术+场景+服务”缺一不可",
          "text": "加强与产业链上下游企业的协同创新，用科技为人们的安全智能出行保驾护航。",
          "date": "2021.04.01",
        },
        {
          "src":"https://mp.weixin.qq.com/s/Fq_u62OiW90YA5IPiaL4-g",
          "img": require("../assets/images/xwll.png"),
          "title": "开易科技接受采访，畅谈行业与公司发展",
          "text": "加速技术应用创新，为行业繁荣创造更多可能。",
          "date": "2021.02.07",
        },
        {
          "src":"https://mp.weixin.qq.com/s/6KPXKu8Vnve2sJ0yi8-Ddg",
          "img": require("../assets/images/xwii.jpg"),
          "title": "严正声明",
          "text": "开易科技严正声明",
          "date": "2021.1.27",
        },
        {
          "src":"https://mp.weixin.qq.com/s/YuBlFtMXjN1rpcSzg4Cqzw",
          "img": require("../assets/images/xwmm.png"),
          "title": "连夺三项大奖，开易科技用实力加速“领跑之势",
          "text": "连续三年勇夺金球奖年度大奖，充分彰显公司的稳健发展实力。",
          "date": "2020.12.18",
        },
        {
          "src":"https://mp.weixin.qq.com/s/ZnljDeViyzOJiNIAVlT1NA",
          "img": require("../assets/images/xwnn.png"),
          "title": "开易科技实力斩获雷锋网“最佳ADAS产品体验奖”",
          "text": "雷锋网公布「2020最佳AI新基建年度榜」，开易科技斩获 “最佳ADAS产品体验奖”。",
          "date": "2020.12.03",
        },
        {
          "src":"https://mp.weixin.qq.com/s/vUISGJY96PMNgRdK63ZQfQ",
          "img": require("../assets/images/xwhh.png"),
          "title": "开易科技：低调中前行的ADAS生力军",
          "text": "“过去的一年”、“未来的几年”、“开易的成绩和愿景”，刘鹏一一道来。",
          "date": "2020.08.31",
        },
        {
          "src":"https://mp.weixin.qq.com/s?__biz=MzIxOTc1NzA5MQ==&mid=2247484484&idx=1&sn=ea56094bab34b65ebc5f47f87b9227a3&chksm=97d72b08a0a0a21e2869a4ea1701100dcf74d9cc85b69f136b03d444931e4361d837aed7521b&token=201203454&lang=zh_CN",
          "img": require("../assets/images/xwjj.png"),
          "title": "开易科技助力禹城市开展道路运输主动安全示范项目",
          "text": "自今年年初起，开易科技已与禹城市交管部门在主动安全业务方面开展了业务探索。",
          "date": "2020.05.25",
        },
        {
          "src":"https://mp.weixin.qq.com/s?__biz=MzIxOTc1NzA5MQ==&mid=2247484411&idx=1&sn=7253150ef4e6f23324027411f0ed5c5a&chksm=97d72cb7a0a0a5a129691ea9388ad60627ddf385d6766e8581f97e8eebe80c08d8d4740a1b3f&token=201203454&lang=zh_CN",
          "img": require("../assets/images/xwff.jpg"),
          "title": "开易科技再次获评毕马威中国汽车科技新锐企业",
          "text": "开易科技第二次入围该榜，更加彰显了公司的创新实力与发展潜力。",
          "date": "2020.04.21",
        },
         {
          "src":"http://chinabang.technode.com/2020/2020/01/21/china-bang-创新企业-开易科技：做安全驾驶的赋能者/",
          "img": require("../assets/images/xwee.png"),
          "title": "开易科技：做安全驾驶的赋能者",
          "text": "眼下，开易科技已经形成了多元化产品矩阵，在多个场景内实现了商业化。",
          "date": "2020.1.21",
        },
        {
          "src":"https://mp.weixin.qq.com/s?__biz=MzIxOTc1NzA5MQ==&mid=2247484337&idx=1&sn=e17077a7b0c5d75e16ddc8b43a4c1ad4&chksm=97d72cfda0a0a5eba2e9a4a1e1b730cb47ed973508e687329c0e7b08b3f4eebfc9be4e1ee729&token=494156529&lang=zh_CN#rd",
          "img": require("../assets/images/xwdd.png"),
          "title": "再获高工智能汽车金球奖，开易科技持续推动汽车智能化升级",
          "text": "紧抓市场机遇，深耕技术创新",
          "date": "2019.12.25",
        },
         {
          "src":"https://mp.weixin.qq.com/s?__biz=MzIxOTc1NzA5MQ==&mid=2247484327&idx=1&sn=c964ae3d87e21ef75ab63449f15b5b3a&chksm=97d72ceba0a0a5fd2e75ffb58a7cc71010daeb438fdf227dc2e4f3f9fa23cde5857a5638e5de&token=494156529&lang=zh_CN#rd",
          "img": require("../assets/images/xwcc.png"),
          "title": "AI掘金，开易科技喜提“最佳ADAS解决方案”奖项",
          "text": "开易科技凭借着过硬的AI感知技术与丰富的落地经验，与腾讯车联、四维图新、旷视等各行业领先企业共同入围该榜",
          "date": "2019.12.18",
        },
        {
          "src":"https://mp.weixin.qq.com/s?__biz=MzIxOTc1NzA5MQ==&mid=2247484337&idx=1&sn=e17077a7b0c5d75e16ddc8b43a4c1ad4&chksm=97d72cfda0a0a5eba2e9a4a1e1b730cb47ed973508e687329c0e7b08b3f4eebfc9be4e1ee729&token=494156529&lang=zh_CN#rd",
          "img": require("../assets/images/xwbb.png"),
          "title": "开易科技喜获猎云网2019年度自动驾驶领域最具影响力创新企业",
          "text": "开易科技凭借在智能驾驶主动安全领域的优异表现，成功斩获“2019年度自动驾驶领域最具影响力创新企业TOP10”奖项。",
          "date": "2019.12.10",
        },
         {
          "src":"https://mp.weixin.qq.com/s/D0UAD-x0sWfc6O_jKS_-FQ",
          "img": require("../assets/images/xwr.jpg"),
          "title": "刚刚完成A+轮融资的开易科技，又捧回毕马威2018汽车科技大奖",
          "text": "开易科技通过在汽车主动安全技术方面的持续创新和迅猛发展，荣登毕马威2018汽车科技新锐榜",
          "date": "2019.6.06",
        },
        {
          "src":"https://36kr.com/p/5206503",
          "img": require("../assets/images/xwrs.jpg"),
          "title": "36氪独家 | 获 1 亿元 A+ 轮融资，辅助驾驶技术服务商「开易科技」已与芯片、网约车头部企业达成合作",
          "text": "高精确度辅助驾驶安全算法公司「开易科技」已于近日完成 A+ 轮 1 亿元人民币融资，本轮领投方为尚珹投资，原股东华泰新产业基金跟投。",
          "date": "2019.6.04",
        },
       
         {
          "src":"https://mp.weixin.qq.com/s/lAIMXAH8TMhUAtFDaPcq2A",
          "img": require("../assets/images/xwv.jpg"),
          "title": "「GGAI头条」ADAS新贵开易科技寒冬逆势增长，累计出货近千万台",
          "text": "开易科技以SDK的方式在后装市场实现了ADAS技术的商业化，出货量已达数百万规模，SDK在智能后视镜中的应用总占比超过90",
          "date": "2019.4.15",
        },
         {
          "src":"https://mp.weixin.qq.com/s/zmOcKZm6tJ7HwBwWCPKEBw",
          "img": require("../assets/images/xww.jpg"),
          "title": "再夺两项汽车主动安全大奖，开易科技闪耀CITE2019",
          "text": "开易科技荣获2019中国汽车主动安全设备十佳企业、2019中国汽车主动安全十佳新锐人物两项大奖，惊艳亮相CITE2019",
          "date": "2019.4.10",
        },
        {
          "src":"https://mp.weixin.qq.com/s/JmKNPkWKDKmG8nf-1UcSEA",
          "img": require("../assets/images/xwq.png"),
          "title": "勇夺3项智能驾驶大奖，开易科技力推行业向前发展",
          "text": "开易科技不负众望，在数百家参选企业里脱颖而出，一举拿下“年度自动驾驶及ADAS类创新产品”、“年度国产商用车ADAS方案商”以及“年度国产DMS方案供应商”三项大奖。",
          "date": "2019.1.16",
        },
        {
          "src":"https://mp.weixin.qq.com/s/B1zLKTmp-zFifm_WHf7I7Q",
          "img": require("../assets/images/xwp.jpg"),
          "title": "开易科技斩获中国汽车科技创新企业50强",
          "text": "开易科技凭借出色的技术原创力与优秀的市场表现，斩获2018中国汽车科技创新企业50强。未来，将继续发力智能驾驶技术的创新与应用，推动产业加速。",
         "date":'2018.12.20'
        },
       
         {
          "src":"http://ifenxi.com/archives/4437",
          "img": require("../assets/images/xwg.jpg"),
          "title": "开易科技用算法优化赋能产业发展，前后装市场齐头并进",
          "text": "主打单目视觉ADAS解决方案的开易科技，以后装与前装产品，同时覆盖商用与乘用市场。",
          "date": "2018.11.21",
        },
        {
          "src":"https://mp.weixin.qq.com/s?__biz=MzA3MzI4MjgzMw==&mid=2650727126&idx=5&sn=ae25ee486eb866ad28c1ea0baecdbbb5&chksm=871b26a8b06cafbe503132bb7dae216e64238c7805830d29e7952f01b5c3db45eb4f40f11a25&mpshare=1&scene=2&srcid=0528oYNzeFBZi70FnZb1veCH&key=0ee500f7354eb251754af8f86e0d65dbe36f535c0f36bfe52b56b830c7f1b20969ef7162b7de9bf000a217e93375a0d0d494f0f385d263550c7b213af165c669ed98a26e639dabf3a292d7618a57ad42&ascene=0&uin=MTA5MzQzNDUyMA%3D%3D&devicetype=iMac+MacBookPro11%2C2+OSX+OSX+10.12.4+build(16E195)&version=12020710&nettype=WIFI&fontScale=100&pass_ticket=BlEpe9OcCrsgpovaaohcvFnxZGGN9UTlJHN4MRIDnqBgofiZ4zc5oY9ZLHa2TNty",
          "img": require("../assets/images/xwa.jpg"),
          "title": "后装炫技，前装务实？这家公司循序渐进切入ADAS市场",
          "text": "开易科技将深度学习落地为重点布局方向，最大程度地挖掘其每月增加百万级数据量的价值。",
          "date": "2017.5.27",
        },
        {
          "src":"https://mp.weixin.qq.com/s?__biz=MzIxOTc1NzA5MQ==&mid=2247483737&idx=1&sn=e46dc65db454ee5d715185dd585c3ac0&chksm=97d72e15a0a0a703d2b0d64c884f9aca5f0ac7d5aa19122246a4591efb66b6f199f5ad80f8cc&mpshare=1&scene=1&srcid=05248I1247VKx0hyRl76Jycm&key=972a9dbb5a3e4fba992e85ff74e8cb7e666111e5fe34e20004931ae617b9f5786da6cf256c3efd72ea18bf77ef3edd56e1ec48ce7d7a6993b1042c14a3f12ee85e752e7f0b3641d37a51d9982115c9a9&ascene=0&uin=MTA5MzQzNDUyMA%3D%3D&devicetype=iMac+MacBookPro11%2C2+OSX+OSX+10.12.4+build(16E195)&version=12020710&nettype=WIFI&fontScale=100&pass_ticket=kj%2FOcKAZQN62IkspXpP%2B1VKlNZDxYB6i6sP5%2FmWQjDmMDiKgwvB5gxbnpHc0%2Fs%2F5",
          "img": require("../assets/images/xwb.jpg"),
          "title": "感谢京东买家对开易ADAS的赞美与支持",
          "text": "小米旗下后视镜产品--70迈智能后视镜自5月8日上线京东，仅仅3天时间，就收获上百条好评。开易科技作为此款后视镜ADAS的技术提供者，收获了买家无数点赞",
          "date": "2017.5.11",
        },
        { 
          "src":"https://mp.weixin.qq.com/s?__biz=MzAxNjk5NjIzNw==&mid=2247484851&idx=2&sn=cf58a6be71426c04dce7a521ad1a29b1&chksm=9bed0751ac9a8e47854b259f0a14c58247a947d2ac27102dad4981874a8baf4303e8710436f8&mpshare=1&scene=1&srcid=04072aARdREGtx6r1R6akJqS&key=972a9dbb5a3e4fbae02400d6818878ff30457c46de4dc320aa6b1ab5fbac1ffda93be90d314daa4904f55b6ab0412f5947b441a26ac45be25b8f04be7f9211791422132b9a226866ee0dc1009ef410b6&ascene=0&uin=MTA5MzQzNDUyMA%3D%3D&devicetype=iMac+MacBookPro11%2C2+OSX+OSX+10.12.4+build(16E195)&version=12020710&nettype=WIFI&fontScale=100&pass_ticket=kj%2FOcKAZQN62IkspXpP%2B1VKlNZDxYB6i6sP5%2FmWQjDmMDiKgwvB5gxbnpHc0%2Fs%2F5",
          "img": require("../assets/images/xwc.jpg"),
          "title": "成立不到一年，开易科技为什么能覆盖后装ADAS 80%的市场？",
          "text": "「我们在去年 12 月就有流水了。」开易科技 CEO 刘鹏告诉雷锋网新智驾。这家 ADAS 公司成立于去年 6 月，不到一年的时间里，开易在前装和后装都有不俗的成绩",
          "date": "2017.4.7",
        },
        {
          "src":"http://m.cheyun.com/content/15649?from=timeline&isappinstalled=0",
          "img": require("../assets/images/xwd.jpg"),
          "title": "为什么这家ADAS创业公司能拿下小米后视镜的订单？",
          "text": "开易科技并不是入局最早的一家，但却已快速浮出水面。",
          "date": "2017.4.4",
        },
         { 
          "src":"https://36kr.com/p/5064553.html?from=timeline&isappinstalled=1",
          "img": require("../assets/images/xwf.jpg"),
          "title": "adas创业如何切入？“开易科技”希望前后装两手抓，后装占据80%市场份额",
          "text": "开易目前在国内联网后视镜的后装ADAS覆盖已经接近80% 。",
          "date": "2017.3.10",
        }
      ]
    }
  },
  components: { headerbar },
  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`          //document.body.clientWidth;
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function() {
      this.changeFixed(this.clientHeight)
    }
  },
  methods: {
    changeFixed(clientHeight) {                        //动态修改样式
      // this.$refs.JournalismPage.style.height = clientHeight - 80 + 'px';
    },
    newsbutton(_src){
         window.open(_src);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Journalism_wrap {
  width: 100%;
  height: 360px;
  background: url("../assets/images/Bitmap1.png");
  background-size: 100% 100%;
}

.Journalism_banner {
  width: 78%;
  margin: 0 auto;
}

.Journalism_banner p {
  text-align: center;
  height: 360px;
  line-height: 360px;
  font-size: 56px;
  /* font-family: PingFangSC-Semibold; */
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  letter-spacing: 1px;
}

.Journalism_wrapa {
  margin-bottom: 180px;
}

.Journalism_news {
  width: 78%;
  margin: 0 auto;
}

.Journalism_news_content ul {
  width: 1000px;
  margin: 0 auto;
}

.Journalism_news_content li {
  display: block;
  float: left;
  width: 260px;
  height: 350px;
  margin-left: 58px;
  margin-top: 92px;
  cursor:pointer;
}

.Journalism_news_img {
  width: 260px;
  height: 124px;
}

.Journalism_news_img img {
  width: 100%;
  height: 100%;
}

.Journalism_news_content li h3 {
  width:271px;
  font-size: 16px;
  height:60px;
  /* font-family: PingFangSC-Semibold; */
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  /*line-height: 20px;*/
  margin-top: 16px;
}

.Journalism_news_content li p {
  font-size: 14px;
  height:90px;
  /* font-family: PingFangSC-Regular; */
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  margin-top: 16px;
}

.Journalism_news_content li h6 {
  margin-top: 32px;
  font-size: 12px;
  /* font-family: PingFangSC-Regular; */
  font-weight: 400;
  color: rgba(141, 141, 146, 1);
  line-height: 20px;
}

.Journalism_news_content li span {
  display: inline-block;
  width: 260px;
  height: 2px;
  background: #ccc;
  margin-top: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/Journalism.vue